// TODO: Remove this file when the /brands API endpoint is ready.
import { Injectable, signal } from '@angular/core';
import { DemoScenario } from './brand.mock-data';

/**
 * Holds the currently selected demo scenario so that BrandResourceDev can read
 * it at subscription time without the scenario leaking into production service APIs.
 *
 * Remove alongside BrandResourceDev and the demo-switcher UI once the real API is wired.
 */
@Injectable({ providedIn: 'root' })
export class BrandDemoScenarioService {
    private readonly _scenario = signal<DemoScenario>('populated');
    readonly scenario = this._scenario.asReadonly();

    // TODO: Remove removedBrandIds, markRemoved, and restore when wired to a real API.
    // Tracks brands optimistically removed from the queue (via Create New Brand) before the
    // API write is committed. BrandResourceDev filters these out of getAll / count queries.
    private readonly _removedBrandIds = signal(new Set<number>());
    readonly removedIds = this._removedBrandIds.asReadonly();

    setScenario(s: DemoScenario): void {
        this._scenario.set(s);
        // Reset optimistic removals on scenario change so the switcher gives a fresh state.
        this._removedBrandIds.set(new Set());
    }

    markRemoved(brandId: number): void {
        this._removedBrandIds.update(ids => new Set([...ids, brandId]));
    }

    restore(brandId: number): void {
        this._removedBrandIds.update(ids => {
            const next = new Set(ids);
            next.delete(brandId);
            return next;
        });
    }
}
